(function () {
  var KEY = 'av_breadcrumb_trail';
  var CONT = 'av_breadcrumb_continue';
  var MAX = 4;

  var ctxEl = document.getElementById('BreadcrumbContext');
  if (!ctxEl) return;

  var ctx;
  var store;
  try {
    ctx = JSON.parse(ctxEl.textContent);
    store = window.sessionStorage;
    store.getItem(KEY);
  } catch (e) {
    return;
  }

  function readTrail() {
    try {
      var value = JSON.parse(store.getItem(KEY));
      return Array.isArray(value) ? value : [];
    } catch (e) {
      return [];
    }
  }

  document.addEventListener(
    'click',
    function (event) {
      var link = event.target.closest && event.target.closest('a[href]');
      if (!link) return;
      var url;
      try {
        url = new URL(link.href, window.location.href);
      } catch (e) {
        return;
      }
      if (url.origin !== window.location.origin) return;
      try {
        if (link.closest('#MainContent')) {
          store.setItem(CONT, url.pathname);
        } else {
          store.removeItem(CONT);
        }
      } catch (e) {}
    },
    true
  );

  var trail = readTrail();
  var continuing = store.getItem(CONT) === ctx.url;
  var current = { title: ctx.title, url: ctx.url };

  if (ctx.type === 'home') {
    trail = [];
  } else if (ctx.type === 'collection' || ctx.type === 'page') {
    var index = -1;
    for (var i = 0; i < trail.length; i++) {
      if (trail[i].url === ctx.url) index = i;
    }
    if (index >= 0) {
      trail = trail.slice(0, index + 1);
    } else if (continuing && trail.length) {
      trail.push(current);
    } else {
      trail = [current];
    }
    trail = trail.slice(-MAX);
  } else if (ctx.type !== 'product') {
    trail = [];
  }

  try {
    store.setItem(KEY, JSON.stringify(trail));
  } catch (e) {}

  if (ctx.type !== 'collection' && ctx.type !== 'product') return;

  var nav = document.querySelector('.breadcrumbs');
  if (!nav) return;
  // Caminho já construído a partir do menu (no servidor): não reescrever
  if (nav.hasAttribute('data-menu-path')) return;
  var home = nav.querySelector('a');
  if (!home) return;

  var items;
  var lastText;
  var builtMenuPath = false;
  var existingLast = nav.querySelector('.breadcrumbs--last');
  var existingText = existingLast ? existingLast.textContent.trim() : '';

  // Caminho pelo menu de departamentos (índice emitido em sections/header.liquid)
  (function buildMenuPath() {
    var MENU_KEY = 'av_menu_entry';

    function plainPath(path) {
      var p = (path || '').split('?')[0].split('#')[0];
      try {
        p = decodeURIComponent(p);
      } catch (e) {}
      return p.replace(/\/+$/, '') || '/';
    }

    // Produto aberto a partir de uma coleção: reutiliza o caminho da coleção guardado,
    // mas só se o produto pertencer mesmo a essa coleção e se viemos dela
    var storedEntry = null;
    if (ctx.type === 'product') {
      try {
        var raw = JSON.parse(store.getItem(MENU_KEY));
        if (raw && raw.u) {
          var inProductCollections = false;
          var productCollections = ctx.collections || [];
          for (var pc = 0; pc < productCollections.length; pc++) {
            if (collectionHandle(productCollections[pc]) === collectionHandle(raw.u)) inProductCollections = true;
          }
          var cameFromCollection = false;
          if (document.referrer) {
            try {
              var refUrl = new URL(document.referrer);
              cameFromCollection =
                refUrl.origin === window.location.origin &&
                collectionHandle(refUrl.pathname) !== '' &&
                collectionHandle(refUrl.pathname) === collectionHandle(raw.u);
            } catch (e) {}
          }
          // Veio mesmo dessa coleção (página anterior): é prova suficiente. Caso contrário,
          // só reutiliza se o produto pertencer à coleção guardada e o clique veio da página principal.
          if (cameFromCollection) {
            storedEntry = raw;
          } else if (continuing && inProductCollections) {
            storedEntry = raw;
          }
        }
      } catch (e) {}
    }

    // Handle da coleção num endereço (ignora a parte do filtro/etiqueta: /collections/<handle>/<etiqueta>)
    function collectionHandle(path) {
      var m = plainPath(path).match(/\/collections\/([^\/]+)/i);
      return m ? m[1].toLowerCase() : '';
    }

    // Coleções do produto, com a coleção de onde o visitante veio (se houver) em primeiro lugar
    function orderedProductCollections() {
      var list = (ctx.collections || []).slice();
      if (!document.referrer || !list.length) return list;
      try {
        var refUrl2 = new URL(document.referrer);
        if (refUrl2.origin !== window.location.origin) return list;
        var refHandle = collectionHandle(refUrl2.pathname);
        if (!refHandle) return list;
        var first = [];
        var rest = [];
        for (var oc = 0; oc < list.length; oc++) {
          if (collectionHandle(list[oc]) === refHandle) first.push(list[oc]);
          else rest.push(list[oc]);
        }
        return first.concat(rest);
      } catch (e) {
        return list;
      }
    }

    // Caminho a partir da cópia do sub-menu do departamento (o que o visitante vê no sub-menu)
    var snapshotCtx = null;
    try {
      snapshotCtx = JSON.parse(store.getItem('departmentContext'));
    } catch (e) {}
    var snapshotTargets = ctx.type === 'product' ? orderedProductCollections() : [ctx.url];

    // Departamento preferido nos produtos: o do produto anterior, se vimos de outro produto
    var cameFromProductPage = false;
    if (ctx.type === 'product' && document.referrer) {
      try {
        var refProd = new URL(document.referrer);
        cameFromProductPage = refProd.origin === window.location.origin && /\/products\//.test(refProd.pathname);
      } catch (e) {}
    }
    var lastDept = null;
    if (cameFromProductPage) {
      try {
        lastDept = JSON.parse(store.getItem('av_last_dept'));
      } catch (e) {}
    }

    // Produto aberto diretamente a partir da página do departamento (destaques, banners):
    // mostra só o caminho percorrido (Início › Departamento › Produto)
    if (ctx.type === 'product' && snapshotCtx && snapshotCtx.url && snapshotCtx.title && document.referrer) {
      try {
        var deptRef = new URL(document.referrer);
        if (deptRef.origin === window.location.origin && plainPath(deptRef.pathname) === plainPath(snapshotCtx.url)) {
          while (home.nextSibling) nav.removeChild(home.nextSibling);
          addCrumb(snapshotCtx.title, snapshotCtx.url);
          try {
            store.setItem('av_last_dept', JSON.stringify({ u: snapshotCtx.url, t: snapshotCtx.title }));
          } catch (e) {}
          addLast(ctx.title);
          nav.setAttribute('data-menu-path', 'true');
          builtMenuPath = true;
          return;
        }
      } catch (e) {}
    }

    // Produto aberto a partir de uma página do site que não é coleção, produto nem departamento
    // (página inicial, pesquisa, blog, carrinho...): mostra só o caminho percorrido (Início › Produto)
    if (ctx.type === 'product' && !storedEntry && document.referrer) {
      try {
        var otherRef = new URL(document.referrer);
        if (otherRef.origin === window.location.origin) {
          var otherPath = plainPath(otherRef.pathname);
          if (!/\/collections\/|\/products\//.test(otherPath)) {
            while (home.nextSibling) nav.removeChild(home.nextSibling);
            try {
              store.removeItem('av_last_dept');
            } catch (e) {}
            addLast(ctx.title);
            nav.setAttribute('data-menu-path', 'true');
            builtMenuPath = true;
            return;
          }
        }
      } catch (e) {}
    }

    // Caminhos por "Marcas" (Marcas › Saro) não são categorias: tratados à parte nos produtos
    function isBrandEntry(e) {
      var anc = (e && e.a) || [];
      for (var bi = 1; bi < anc.length; bi++) {
        if (plainText(anc[bi][0]) === 'marcas') return true;
      }
      return false;
    }
    function plainText(text) {
      return (text || '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/\s+/g, ' ')
        .trim();
    }

    function entryFromSnapshot(skipBrand) {
      if (!snapshotCtx || !snapshotCtx.html || !snapshotCtx.url) return null;
      var doc;
      try {
        doc = new DOMParser().parseFromString(snapshotCtx.html, 'text/html');
      } catch (e) {
        return null;
      }
      var anchors = doc.querySelectorAll('.department-subnav a[href]');
      for (var pass = 0; pass < 2; pass++) {
       for (var ti = 0; ti < snapshotTargets.length; ti++) {
        var wanted = plainPath(snapshotTargets[ti]);
        var wantedHandle = collectionHandle(wanted);
        for (var ai = 0; ai < anchors.length; ai++) {
          var target = anchors[ai];
          var targetPath;
          try {
            targetPath = plainPath(new URL(target.getAttribute('href'), window.location.origin).pathname);
          } catch (e) {
            continue;
          }
          if (pass === 0 && targetPath !== wanted) continue;
          if (pass === 1 && (!wantedHandle || collectionHandle(targetPath) !== wantedHandle)) continue;

          var crumbs = [];
          var node = target;
          var guard = 0;
          while (node && guard++ < 6) {
            var list = node.closest('ul');
            if (!list) break;
            var owner = list.previousElementSibling;
            if (!owner || owner.tagName !== 'A') break;
            crumbs.unshift([owner.textContent.replace(/\s+/g, ' ').trim(), owner.getAttribute('href')]);
            node = owner;
          }
          var item = target.closest('.department-subnav__item');
          var summary = item ? item.querySelector('summary') : null;
          var heading = summary ? summary.textContent.replace(/\s+/g, ' ').trim() : '';
          var trail = [[snapshotCtx.title || '', snapshotCtx.url]];
          if (heading) trail.push([heading, summary ? summary.getAttribute('data-link') || '' : '']);
          var snapshotResult = {
            u: wanted,
            t: target.textContent.replace(/\s+/g, ' ').trim(),
            a: trail.concat(crumbs)
          };
          if (skipBrand && isBrandEntry(snapshotResult)) continue;
          return snapshotResult;
        }
       }
      }
      return null;
    }
    var snapshotEntry = entryFromSnapshot(ctx.type === 'product');

    var indexEl = document.getElementById('DepartmentMenuIndex');
    var index = [];
    if (indexEl) {
      try {
        index = JSON.parse(indexEl.textContent);
      } catch (e) {
        index = [];
      }
    }
    if (!Array.isArray(index)) index = [];
    if (!index.length && !storedEntry && !snapshotEntry) {
      if (window.console && console.info) console.info('[breadcrumbs] índice do menu vazio ou em falta');
      return;
    }

    function norm(path) {
      var p = (path || '').split('?')[0].split('#')[0];
      try {
        p = decodeURIComponent(p);
      } catch (e) {}
      return p.replace(/\/+$/, '') || '/';
    }

    var targets = ctx.type === 'product' ? orderedProductCollections() : [ctx.url];
    var departmentUrl = '';
    var departmentTitle = '';
    try {
      var saved = JSON.parse(store.getItem('departmentContext'));
      if (saved && saved.url) departmentUrl = norm(saved.url);
      if (saved && saved.title) departmentTitle = saved.title;
    } catch (e) {}

    function plain(text) {
      return (text || '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/\s+/g, ' ')
        .trim();
    }

    var preferredDeptUrl = departmentUrl;
    var preferredDeptTitle = departmentTitle;
    if (lastDept && lastDept.u) {
      preferredDeptUrl = norm(lastDept.u);
      preferredDeptTitle = lastDept.t || departmentTitle;
    }
    // A cópia do sub-menu só serve se for do departamento preferido
    if (snapshotEntry && preferredDeptUrl && snapshotCtx && norm(snapshotCtx.url) !== preferredDeptUrl) {
      snapshotEntry = null;
    }

    var entry = storedEntry || snapshotEntry;

    // Produto aberto a partir de outro produto (relacionados): caminho simples (Início › Departamento › Produto).
    // Usa o departamento do produto anterior só se este produto também pertencer a ele;
    // caso contrário usa o departamento do próprio produto.
    if (cameFromProductPage) {
      var relatedMatches = [];
      for (var rt = 0; rt < targets.length; rt++) {
        var relatedTarget = norm(targets[rt]);
        var relatedFound = index.filter(function (item) {
          return norm(item.u) === relatedTarget;
        });
        if (!relatedFound.length && collectionHandle(relatedTarget)) {
          relatedFound = index.filter(function (item) {
            return collectionHandle(item.u) === collectionHandle(relatedTarget);
          });
        }
        relatedMatches = relatedMatches.concat(relatedFound);
      }
      var relatedPreferred = relatedMatches.filter(function (item) {
        return !isBrandEntry(item);
      });
      var relatedAll = relatedPreferred.concat(relatedMatches);
      var inPreviousDept = false;
      if (lastDept && lastDept.u) {
        for (var ri = 0; ri < relatedAll.length; ri++) {
          if (relatedAll[ri].a && relatedAll[ri].a[0] && norm(relatedAll[ri].a[0][1]) === norm(lastDept.u)) {
            inPreviousDept = true;
            break;
          }
        }
      }
      if (!lastDept || !lastDept.u) {
        // O produto anterior não tinha departamento (aberto da página inicial, pesquisa...): sem departamento
        entry = { simple: true, a: [], t: '', u: '' };
      } else if (inPreviousDept) {
        entry = { simple: true, a: [[lastDept.t || preferredDeptTitle, lastDept.u]], t: '', u: '' };
      } else if (relatedAll.length && relatedAll[0].a && relatedAll[0].a[0]) {
        entry = { simple: true, a: [relatedAll[0].a[0]], t: '', u: '' };
      } else {
        entry = { simple: true, a: [], t: '', u: '' };
      }
    }

    if (!entry && ctx.type === 'product') {
      var nonBrand = [];
      var brandOnly = [];
      for (var pt = 0; pt < targets.length; pt++) {
        var productTarget = norm(targets[pt]);
        var found = index.filter(function (item) {
          return norm(item.u) === productTarget;
        });
        if (!found.length && collectionHandle(productTarget)) {
          found = index.filter(function (item) {
            return collectionHandle(item.u) === collectionHandle(productTarget);
          });
        }
        for (var fi = 0; fi < found.length; fi++) {
          (isBrandEntry(found[fi]) ? brandOnly : nonBrand).push(found[fi]);
        }
      }
      var sameDept = nonBrand.filter(function (item) {
        return item.a && item.a[0] && norm(item.a[0][1]) === preferredDeptUrl;
      });
      if (preferredDeptUrl && sameDept.length) {
        entry = sameDept[0];
      } else if (preferredDeptUrl && preferredDeptTitle) {
        entry = { simple: true, a: [[preferredDeptTitle, preferredDeptUrl]], t: '', u: '' };
      } else if (nonBrand.length) {
        entry = nonBrand[0];
      } else if (brandOnly.length && brandOnly[0].a && brandOnly[0].a[0]) {
        entry = { simple: true, a: [brandOnly[0].a[0]], t: '', u: '' };
      }
    } else if (!entry) {
      var firstMatch = null;
      var departmentMatch = null;
      for (var t = 0; t < targets.length; t++) {
        var target = norm(targets[t]);
        var matches = index.filter(function (item) {
          return norm(item.u) === target;
        });
        if (!matches.length && collectionHandle(target)) {
          matches = index.filter(function (item) {
            return collectionHandle(item.u) === collectionHandle(target);
          });
        }
        if (!matches.length) continue;
        if (!firstMatch) firstMatch = matches[0];
        if (departmentUrl && !departmentMatch) {
          for (var m = 0; m < matches.length; m++) {
            if (matches[m].a && matches[m].a[0] && norm(matches[m].a[0][1]) === departmentUrl) {
              departmentMatch = matches[m];
              break;
            }
          }
        }
      }
      entry = departmentMatch || firstMatch;
    }
    // Sem correspondência por URL: tenta pelo título da coleção
    if (!entry && ctx.type === 'collection' && ctx.title) {
      var wanted = plain(ctx.title);
      var byTitle = index.filter(function (item) {
        return plain(item.t) === wanted;
      });
      if (byTitle.length) {
        entry = byTitle[0];
        if (departmentUrl) {
          for (var k = 0; k < byTitle.length; k++) {
            if (byTitle[k].a && byTitle[k].a[0] && norm(byTitle[k].a[0][1]) === departmentUrl) {
              entry = byTitle[k];
              break;
            }
          }
        }
      }
    }

    // Ainda sem correspondência: mostra pelo menos o departamento por onde o visitante entrou
    if (!entry && ctx.type === 'collection' && departmentTitle && departmentUrl) {
      while (home.nextSibling) nav.removeChild(home.nextSibling);
      var deptSep = document.createElement('span');
      deptSep.setAttribute('aria-hidden', 'true');
      deptSep.className = 'breadcrumbs--sep';
      nav.appendChild(deptSep);
      var deptLink = document.createElement('a');
      deptLink.href = departmentUrl;
      deptLink.className = 'reversed-link';
      deptLink.textContent = departmentTitle;
      nav.appendChild(deptLink);
      var lastSep = document.createElement('span');
      lastSep.setAttribute('aria-hidden', 'true');
      lastSep.className = 'breadcrumbs--sep';
      nav.appendChild(lastSep);
      var lastSpan = document.createElement('span');
      lastSpan.className = 'breadcrumbs--last text-subtext';
      lastSpan.setAttribute('aria-current', 'page');
      lastSpan.textContent = existingText || ctx.title;
      nav.appendChild(lastSpan);
      nav.setAttribute('data-menu-path', 'true');
      builtMenuPath = true;
      return;
    }
    if (!entry) {
      if (window.console && console.info) {
        console.info('[breadcrumbs] sem correspondência no menu para', ctx.type, ctx.url, 'coleções do produto:', ctx.collections, '(' + index.length + ' entradas no índice)');
      }
      return;
    }

    if (ctx.type === 'collection') {
      try {
        store.setItem('av_menu_entry', JSON.stringify({ u: ctx.url, t: entry.t, a: entry.a }));
      } catch (e) {}
    }

    var tagLink = null;
    if (ctx.type === 'collection') {
      var anchors = nav.querySelectorAll('a');
      if (anchors.length > 1) tagLink = true;
    }

    while (home.nextSibling) nav.removeChild(home.nextSibling);

    function sep() {
      var span = document.createElement('span');
      span.setAttribute('aria-hidden', 'true');
      span.className = 'breadcrumbs--sep';
      return span;
    }
    function addCrumb(title, href) {
      nav.appendChild(sep());
      // Links "#" ou vazios no menu = categoria sem ligação: mostrar só texto
      if (href && href.replace(/^\s+|\s+$/g, '').charAt(0) !== '#') {
        var a = document.createElement('a');
        a.href = href;
        a.className = 'reversed-link';
        a.textContent = title;
        nav.appendChild(a);
      } else {
        var s = document.createElement('span');
        s.textContent = title;
        nav.appendChild(s);
      }
    }
    function addLast(text) {
      nav.appendChild(sep());
      var last = document.createElement('span');
      last.className = 'breadcrumbs--last text-subtext';
      last.setAttribute('aria-current', 'page');
      last.textContent = text;
      nav.appendChild(last);
    }

    // Só entram no caminho os níveis clicáveis (links "#" ou vazios são omitidos)
    (entry.a || []).forEach(function (crumb) {
      var crumbHref = crumb[1] ? String(crumb[1]).trim() : '';
      if (!crumbHref || crumbHref.charAt(0) === '#') return;
      addCrumb(crumb[0], crumbHref);
    });

    if (ctx.type === 'product') {
      if (!entry.simple) addCrumb(entry.t, entry.u);
      try {
        if (entry.a && entry.a[0]) store.setItem('av_last_dept', JSON.stringify({ u: entry.a[0][1], t: entry.a[0][0] }));
      } catch (e) {}
      addLast(ctx.title);
    } else if (tagLink) {
      addCrumb(entry.t || ctx.title, ctx.url);
      addLast(existingText);
    } else {
      // Nome tal como está no menu (em vez do título da coleção)
      addLast(entry.t || ctx.title);
    }
    nav.setAttribute('data-menu-path', 'true');
    builtMenuPath = true;
  })();
  if (builtMenuPath) return;

  // Coleção sem caminho de menu (por exemplo, uma marca): guarda o caminho que o visitante vê,
  // para os produtos abertos a partir dela o continuarem
  if (ctx.type === 'collection') {
    window.addEventListener('pagehide', function () {
      try {
        var crumbLinks = nav.querySelectorAll('a');
        var savedCrumbs = [];
        for (var ci = 1; ci < crumbLinks.length; ci++) {
          savedCrumbs.push([crumbLinks[ci].textContent.replace(/\s+/g, ' ').trim(), crumbLinks[ci].getAttribute('href')]);
        }
        var lastNode = nav.lastElementChild;
        var lastLabel = lastNode ? lastNode.textContent.replace(/\s+/g, ' ').trim() : ctx.title;
        store.setItem('av_menu_entry', JSON.stringify({ u: ctx.url, t: lastLabel, a: savedCrumbs }));
      } catch (e) {}
    });
  }

  if (ctx.type === 'product') {
    if (!continuing || !trail.length) return;
    items = trail;
    lastText = ctx.title;
  } else {
    if (trail.length < 2 && existingText === ctx.title) return;
    if (existingText && existingText !== ctx.title) {
      items = trail;
      lastText = existingText;
    } else {
      items = trail.slice(0, -1);
      lastText = ctx.title;
    }
  }

  while (home.nextSibling) nav.removeChild(home.nextSibling);

  function separator() {
    var span = document.createElement('span');
    span.setAttribute('aria-hidden', 'true');
    span.className = 'breadcrumbs--sep';
    return span;
  }

  items.forEach(function (item) {
    nav.appendChild(separator());
    var anchor = document.createElement('a');
    anchor.href = item.url;
    anchor.className = 'reversed-link';
    anchor.textContent = item.title;
    nav.appendChild(anchor);
  });

  nav.appendChild(separator());
  var last = document.createElement('span');
  last.className = 'breadcrumbs--last text-subtext';
  last.setAttribute('aria-current', 'page');
  last.textContent = lastText;
  nav.appendChild(last);
})();
